/**
 * Do not edit directly
 * Generated on Wed, 08 Oct 2025 16:21:37 GMT
 */

export const zigzag = "/assets/shapes/zigzag.svg";
export const wave = "/assets/shapes/wave.svg";
export const tab = "/assets/shapes/tab.svg";
export const stack = "/assets/shapes/stack.svg";
export const scallop = "/assets/shapes/scallop.svg";
export const holepunch = "/assets/shapes/holepunch.svg";
export const cutter = "/assets/shapes/cutter.svg";
export const cricut = "/assets/shapes/cricut.svg";
export const compass = "/assets/shapes/compass.svg";
export const clover = "/assets/shapes/clover.svg";
export const cap = "/assets/shapes/cap.svg";
export const bookmark = "/assets/shapes/bookmark.svg";
